import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
import { isFlagSet } from 'z3k-parser/lib/flags';
export var RelayControlState;
(function (RelayControlState) {
    RelayControlState[RelayControlState["OFF"] = 0] = "OFF";
    RelayControlState[RelayControlState["ON"] = 1] = "ON";
})(RelayControlState || (RelayControlState = {}));
export var RelayControl;
(function (RelayControl) {
    let Flags;
    (function (Flags) {
        Flags[Flags["IS_INVERSE_MODE_FLAG"] = 1] = "IS_INVERSE_MODE_FLAG";
    })(Flags = RelayControl.Flags || (RelayControl.Flags = {}));
    function isInverse(relay) {
        if (!relay?.setting_register)
            return false;
        return isFlagSet(relay, Flags.IS_INVERSE_MODE_FLAG);
    }
    RelayControl.isInverse = isInverse;
    RelayControl.get = createAccessors(arrayGetSet('relay_controls'), {
        name: 'Реле',
        physical_output: -1,
        setting_register: 0,
    });
})(RelayControl || (RelayControl = {}));
